import React from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import { OpenInNew } from '@mui/icons-material';
// Utils
import {
  PRIVACY_POLICY_URL,
  SUPPORT_EMAIL,
  SUPPORT_MAILTO,
  TERMS_OF_USE_URL,
} from 'utils/legalLinks';

const externalLinkProps = {
  target: '_blank',
  rel: 'noopener noreferrer',
};

const LegalLinks = ({ variant = 'settings' }) => {
  if (variant !== 'settings') {
    return null;
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Support &amp; legal
      </Typography>
      <Stack spacing={1}>
        <Link
          href={PRIVACY_POLICY_URL}
          {...externalLinkProps}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            fontSize: '0.875rem',
          }}
        >
          Privacy Policy
          <OpenInNew sx={{ fontSize: 14 }} />
        </Link>
        <Link
          href={TERMS_OF_USE_URL}
          {...externalLinkProps}
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            fontSize: '0.875rem',
          }}
        >
          Terms of Use
          <OpenInNew sx={{ fontSize: 14 }} />
        </Link>
        <Link href={SUPPORT_MAILTO} sx={{ fontSize: '0.875rem' }}>
          Contact support ({SUPPORT_EMAIL})
        </Link>
      </Stack>
    </Box>
  );
};

export default LegalLinks;
